import * as Sentry from "@sentry/react"
import { SambaTheme } from "ipctg-inflow-types/InFlowThemes"

import { localStore } from "./store"

const THEME_STORAGE_KEY_PREFIX = "theme-"
const themeLogStyle = "color: #8B5CF6; font-weight: bold"

class ThemeStorage {
  private inMemoryCache: Map<string, SambaTheme> = new Map()

  /**
   * Build the localStore key for a given qrLookupID
   */
  private getKey(qrLookupID: string): string {
    return `${THEME_STORAGE_KEY_PREFIX}${qrLookupID}`
  }

  /**
   * Store theme in memory and localStore
   */
  public setTheme(qrLookupID: string, theme: SambaTheme): void {
    const key = this.getKey(qrLookupID)

    // 1) In-memory cache
    this.inMemoryCache.set(qrLookupID, theme)

    // 2) localStore persistence
    try {
      localStore.setItem(key, JSON.stringify(theme))
    } catch (error) {
      Sentry.captureException(error)
      console.error("Failed to cache theme in localStore", error)
    }
  }

  /**
   * Retrieve theme, checking in-memory → localStore
   */
  public getTheme(qrLookupID: string): SambaTheme | null {
    // 1) Check in-memory cache first
    const cached = this.inMemoryCache.get(qrLookupID)
    if (cached) {
      console.log("cache: ", cached)
      console.log(`%cUsing in-memory theme for ${qrLookupID}`, themeLogStyle)
      return cached
    }

    // 2) Check localStore
    const key = this.getKey(qrLookupID)
    const stored = localStore.getItem(key)

    if (stored) {
      try {
        const parsed = JSON.parse(stored) as SambaTheme
        console.log("cache: ", parsed)
        console.log(`%cUsing localStore theme for ${qrLookupID}`, themeLogStyle)

        // Populate in-memory cache
        this.inMemoryCache.set(qrLookupID, parsed)

        return parsed
      } catch (error) {
        Sentry.captureException(error)
        console.error("Failed to parse cached theme", error)
        // Clean up invalid data
        localStore.removeItem(key)
      }
    }

    console.log(`%cNo cached theme for ${qrLookupID}`, themeLogStyle)
    return null
  }
}

const themeStorage = new ThemeStorage()

export default themeStorage
